import countries from 'i18n-iso-countries'
import {handleReloadedContent, reload, showToast, toggleSpinner, updateCart} from "../global/utilities";

const init = () => {
    initializeBookings();
    initializeEvents();
    initializeBuy();
    initializeAccountDetails();
    initializeUserForm();
    initializePhoneAndCountry();
    initializePasswordChange();
    initializeOptins();
    initializeEventCancellation();
    initializeViewMoreSessions();
    initializeViewMorePurchases();
}

// Single DOMContentLoaded listener
document.addEventListener('DOMContentLoaded', () => {
    initializeTabs();
    initializeLogout();
    init();
});
window.addEventListener('contentReady', init);

function initializeBookings() {

    document.querySelectorAll('.go-to-planning').forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const planningTab = document.querySelector('.tabs-heading [data-tab="planning"]');
            if (planningTab) {
                planningTab.click();
            }
        });
    });

}

function initializeTabs() {
    const overlay = document.querySelector('.my-account-overlay');

    const initializeTabSystem = (tabSelector, contentSelector, activeClass = 'active') => {
        const tabs = document.querySelectorAll(tabSelector);
        const contents = document.querySelectorAll(contentSelector);

        tabs?.forEach((tab, i) => {
            tab.addEventListener('click', () => {
                if (tab.classList.contains('active')) {
                    return;
                }

                overlay.style.display = 'flex';

                const targetAttr = tab.dataset.tab || tab.dataset.menuTab;
                const targetContent = contents[i];

                jQuery(targetContent).load(`/my-account-tab-content/${targetAttr}/`, () => {
                    tabs.forEach(t => t.classList.remove(activeClass));
                    contents.forEach(c => {
                        if (c.classList.contains('active')) {
                            c.innerhtml = '';
                        }
                    });

                    tab.classList.add(activeClass);
                    targetContent.classList.add(activeClass);

                    contents.forEach(c => {
                        if (!c.isEqualNode(targetContent) && c.classList.contains('active')) {
                            c.classList.remove('active')
                            c.innerHTML = '';
                        }
                    });

                    overlay.style.display = 'none';

                    handleReloadedContent(targetContent);
                });
            });
        });
    };

    initializeTabSystem('.tabs-heading button', '[data-tab-content]')
}

async function handleFetchResponse(response) {
    if (!response.ok) {
        throw new Error('Erreur de communication avec le serveur');
    }
    return response;
}

function initializeLogout() {
    const logoutButton = document.querySelector('.logout-button');
    logoutButton?.addEventListener('click', (event) => {
        event.preventDefault();
        document.cookie = "resamania_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        reload();
    });
}

function initializeEvents() {
    const dataEvents = document.querySelectorAll('[data-events]');
    if (!dataEvents.length) return;

    document.querySelectorAll('.tab-header [data-events]').forEach(button => {
        button.addEventListener('click', function () {
            const dataEventsValue = this.dataset.events;
            const isActive = this.classList.contains('selected');

            if (!isActive) {
                document.querySelectorAll('[data-events].selected')
                    .forEach(el => el.classList.remove('selected'));
                document.querySelectorAll(`[data-events="${dataEventsValue}"]`)
                    .forEach(el => el.classList.add('selected'));
            }
        });
    });
}

function initializeAccountDetails() {
    const dataAccountDetails = document.querySelectorAll('[data-account-details]');
    if (!dataAccountDetails.length) return;

    document.querySelectorAll('.tab-header [data-account-details]').forEach(button => {
        button.addEventListener('click', function () {
            const dataAccountDetailsValue = this.dataset.accountDetails;
            const isActive = this.classList.contains('selected');

            if (!isActive) {
                document.querySelectorAll('[data-account-details].selected')
                    .forEach(el => el.classList.remove('selected'));
                document.querySelectorAll(`[data-account-details="${dataAccountDetailsValue}"]`)
                    .forEach(el => el.classList.add('selected'));
            }
        });
    });
}

function initializeBuy() {
    const dataSessionsBtn = document.querySelectorAll('button[data-purchase]');
    if (!dataSessionsBtn.length) return;

    dataSessionsBtn.forEach(button => {
        button.addEventListener('click', function () {
            const dataEventsValue = this.dataset.purchase;
            const isActive = this.classList.contains('selected');

            if (!isActive) {
                document.querySelectorAll('[data-purchase].selected')
                    .forEach(el => el.classList.remove('selected'));
                document.querySelectorAll(`[data-purchase="${dataEventsValue}"]`)
                    .forEach(el => el.classList.add('selected'));
            }
        });
    });

    initializeBuySessions();
}

function sessionHasProductsSelected(session) {
    const products = session.querySelectorAll('select');
    let hasSelectedProducts = false;

    products.forEach(product => {
        const options = product.querySelectorAll('option');
        options.forEach(option => {
            if (option.selected && option.dataset.price !== undefined && option.dataset.productId !== undefined) {
                hasSelectedProducts = true;
            }
        });
    });

    return hasSelectedProducts;
}

function initializeBuySessions() {
    const dataSessions = document.querySelectorAll('div[data-purchase]');

    dataSessions.forEach(session => {
        const addToCartBtn = session.querySelector('.add-to-cart');
        const products = session.querySelectorAll('.product');

        if (addToCartBtn) {
            if(session.dataset.purchase !== 'dexa') {
                addToCartBtn.disabled = true;
            }

            addToCartBtn.addEventListener('click', (event) => {
                event.preventDefault();

                const selectedProducts = [];

                products.forEach(product => {
                    let selectedProduct = {};

                    const options = product.querySelectorAll('option');
                    options.forEach(option => {
                        if (option.selected && option.dataset.price !== undefined && option.dataset.productId !== undefined) {
                            selectedProduct.price = option.dataset.price;
                            selectedProduct.productId = option.dataset.productId;
                            selectedProduct.offerId = option.dataset.offerId;
                            selectedProduct.bundleId = option.dataset.bundleId || 0;
                        }
                    });

                    if (Object.keys(selectedProduct).length !== 0) {
                        selectedProduct.implementation = {};

                        const beginDate = product.querySelector('.begin-date');
                        if (beginDate) {
                            selectedProduct.implementation.startDate = beginDate.value;
                        }

                        selectedProducts.push(selectedProduct);
                    }
                });

                if (selectedProducts.length !== 0) {
                    // console.log(selectedProducts);
                    toggleSpinner(addToCartBtn, true);
                    updateCart(selectedProducts, addToCartBtn);
                }
            });
        }

        products.forEach(product => {
            const selects = product.querySelectorAll('select');

            selects.forEach(select => {
                select.addEventListener('change', () => {
                    addToCartBtn.disabled = !sessionHasProductsSelected(session);
                });
            });

            if (selects.length === 2) {
                selects.forEach((select, i) => {
                    select.addEventListener('change', () => {
                        const selectToReset = i === 0 ? selects[1] : selects[0];

                        selectToReset.querySelectorAll('option').forEach(option => {
                            option.selected = false;
                        });
                    });
                });
            }
        });
    });
}

function initializeUserForm() {
    const form = document.querySelector('#addressForm');
    if (!form) return;

    const submitButton = form.querySelector('#submitButton');
    if (!submitButton) return;

    submitButton.disabled = true;

    form.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', () => submitButton.disabled = false);
    });

    submitButton.addEventListener('click', async (event) => {
        event.preventDefault();
        if (submitButton.disabled) return;

        toggleSpinner(submitButton, true);
        const countrySelect = form.querySelector('#addressCountry');

        try {
            const response = await fetch(ajax_object.ajax_url, {
                method: 'POST',
                body: new URLSearchParams({
                    action: 'update_user_infos',
                    email: form.querySelector('#email').value,
                    mobile: form.querySelector('#mobile').value,
                    streetAddress: form.querySelector('#streetAddress').value,
                    postalCode: form.querySelector('#postalCode').value,
                    addressLocality: form.querySelector('#addressLocality').value,
                    addressCountry: countrySelect.options[countrySelect.selectedIndex].text,
                    addressCountryIso: countrySelect.value,
                })
            });

            await handleFetchResponse(response);
            showToast("Informations mises à jour avec succès");
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            toggleSpinner(submitButton, false);
        }
    });
}

function initializePhoneAndCountry() {
    const form = document.querySelector("#addressForm");
    if (!form) return;

    const mobileInput = document.getElementById("mobile");
    const countrySelect = document.getElementById("addressCountry");

    if (mobileInput) {
        window.intlTelInput(mobileInput, {
            initialCountry: "fr",
            loadUtils: () => import("intl-tel-input/utils"),
        });
    }

    if (countrySelect) {
        countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
        const countryList = countries.getNames("fr");

        Object.entries(countryList).forEach(([code, name]) => {
            const option = document.createElement("option");
            option.value = code;
            option.textContent = name;
            option.selected = code === "FR";
            countrySelect.appendChild(option);
        });
    }
}

function initializePasswordChange() {

    const form = document.querySelector(".change-password-container form");
    if (!form) return;

    form.querySelectorAll('input').forEach(input => {
        input.addEventListener('input', () => submitButton.disabled = false);
    });

    const submitButton = form.querySelector("button[type='submit']");
    submitButton.addEventListener("click", async (event) => {
        event.preventDefault();
        if (submitButton.disabled) return;

        toggleSpinner(submitButton, true);

        const currentPassword = form.querySelector("#old").value;
        const newPassword = form.querySelector("#new").value;
        const confirmPassword = form.querySelector("#repeatNew").value;

        if (newPassword !== confirmPassword) {
            showToast("Les mots de passe ne correspondent pas", 'error');
            toggleSpinner(submitButton, false);
            return;
        }

        try {
            const response = await fetch(ajax_object.ajax_url, {
                method: 'POST',
                body: new URLSearchParams({
                    action: 'update_user_password',
                    current_password: currentPassword,
                    new_password: newPassword,
                    _ajax_nonce: ajax_object.nonce
                })
            });

            const data = await response.json();

            if (data.success) {
                showToast("Mot de passe changé avec succès");

                form.reset();
            } else {
                showToast(data.data.message || "Erreur lors du changement de mot de passe", 'error');
            }
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            toggleSpinner(submitButton, false);
        }
    });
}

function initializeOptins() {
    const optins = document.querySelectorAll('.single-optin input[type="checkbox"]');
    const button = document.querySelector('.communication-settings-container-inner button');
    if (!button) return;

    button.addEventListener('click', async (event) => {
        event.preventDefault();
        toggleSpinner(button, true);

        try {
            const requests = Array.from(optins).map(optin =>
                fetch(ajax_object.ajax_url, {
                    method: 'POST',
                    body: new URLSearchParams({
                        action: 'update_optin',
                        optin_id: optin.dataset.optinId,
                        optin_value: optin.checked.toString()
                    })
                }).then(res => res.json())
            );

            const results = await Promise.all(requests);
            const hasError = results.some(result => !result.success);

            showToast(
                hasError
                    ? "Erreur lors de la mise à jour des préférences de communication"
                    : "Vos préférences de communication ont été mises à jour",
                hasError ? 'error' : 'success'
            );
        } catch (error) {
            showToast(error.message, 'error');
        } finally {
            toggleSpinner(button, false);
        }
    });
}

function initializeEventCancellation() {
    document.querySelectorAll('.class-edit[data-attendee]').forEach(button => {
        button.addEventListener('click', async (event) => {
            const overlay = document.getElementById('cancelOverlay');
            const popup = document.getElementById('cancelPopup');
            const attendee = button.dataset.attendee;
            const eventId = button.dataset.eventId;
            const confirmBtn = popup.querySelector('.cancel-popup-confirm');
            const cancelBtn = popup.querySelector('.cancel-popup-close');

            overlay.style.display = 'block';
            popup.style.display = 'block';
            confirmBtn.dataset.attendee = attendee;
            confirmBtn.dataset.eventId = eventId;

            confirmBtn.addEventListener('click', async (e) => {

                e.preventDefault()
                toggleSpinner(confirmBtn, true);

                try {
                    const response = await fetch(ajax_object.ajax_url, {
                        method: 'POST',
                        body: new URLSearchParams({
                            action: 'event_cancel_signup',
                            attendee_id: confirmBtn.dataset.attendee,
                            event_id: confirmBtn.dataset.eventId,
                        })
                    });

                    const data = await handleFetchResponse(response).then(r => r.json());

                    if (data.success) {
                        showToast("Réservation annulé avec succès");
                        jQuery(button).parent('.booking-card').remove();
                    } else {
                        showToast(data.data.message || "Erreur lors de l'annulation de votre réservation", 'error');
                    }
                } catch (error) {
                    showToast(error.message, 'error');
                    overlay.style.display = 'none';
                    popup.style.display = 'none';
                } finally {
                    overlay.style.display = 'none';
                    popup.style.display = 'none';
                    toggleSpinner(confirmBtn, false);
                }
            });

            cancelBtn.addEventListener('click', () => {
                overlay.style.display = 'none';
                popup.style.display = 'none';
            });
        });
    });
}

function hideViewMoreButtonIfNecessary(button, cards, multiple) {
    if (cards.length % multiple !== 0) {
        button.style.display = 'none';
    }
}

function initializeViewMoreSessions() {
    const buttons = document.querySelectorAll('.booking-see-more-btn');

    buttons.forEach((button) => {
        const action = button.dataset.action;
        const sessionWrapper = button.parentElement.previousElementSibling;

        hideViewMoreButtonIfNecessary(button, sessionWrapper.querySelectorAll('.booking-card'), 12);

        button.addEventListener('click', () => {
            const page = parseInt(button.dataset.page);

            toggleSpinner(button, true);

            jQuery.post(ajax_object.ajax_url, {
                action: `get_${action}_sessions`,
                page: page
            }, 'html')
                .done(function (response) {
                    if (response === '') {
                        toggleSpinner(button, false);
                        button.disabled = true;
                    } else {
                        jQuery(sessionWrapper).append(response);
                        toggleSpinner(button, false);
                        button.dataset.page = page + 1;
                    }

                    hideViewMoreButtonIfNecessary(button, sessionWrapper.querySelectorAll('.booking-card'), 12);
                    handleReloadedContent(sessionWrapper, false);
                });
        });
    });
}

function initializeViewMorePurchases() {
    const button = document.querySelector('.purchases-see-more-btn');

    if(!button) {
        return;
    }

    const purchasesWrapper = button.parentElement.previousElementSibling;

    hideViewMoreButtonIfNecessary(button, purchasesWrapper.querySelectorAll('.purchase-card'), 8);

    button.addEventListener('click', () => {
        const page = parseInt(button.dataset.page);

        toggleSpinner(button, true);

        jQuery.post(ajax_object.ajax_url, {
            action: `get_purchases`,
            page: page
        }, 'html')
            .done(function (response) {
                if (response === '') {
                    toggleSpinner(button, false);
                    button.disabled = true;
                } else {
                    jQuery(purchasesWrapper).append(response);
                    toggleSpinner(button, false);
                    button.dataset.page = page + 1;
                }

                hideViewMoreButtonIfNecessary(button, purchasesWrapper.querySelectorAll('.purchase-card'), 8);
                handleReloadedContent(purchasesWrapper, false);
            });
    });
}

document.querySelectorAll('.accordion-title').forEach(btn => {
    btn.addEventListener('click', function () {
        const content = this.nextElementSibling;
        const isOpen = this.classList.contains('active');
        document.querySelectorAll('.accordion-title').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.accordion-content').forEach(c => {
            c.style.maxHeight = null;
            c.style.padding = '0';
        });
        if (!isOpen) {
            this.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.padding = '5px 0 0';
        }
    });
});